import React from 'react';
import PropTypes from 'prop-types';
import imgDefaultUser from '../../../../assets/img/default-user.png';
import RouterUtils from '../../../shared/routing/RouterUtils';
import { PsRoutes } from '../../../shared/routing/Routes';
import { I18nUtils } from '../../../../i18n/I18nUtils';
import { Link } from 'react-router-dom';
import './MessagePreviewListItem.css';

export class MessagePreviewListItem extends React.Component {

    render() {
        const { message } = this.props;
        const toDetail = RouterUtils.generateRoute(
            PsRoutes.MESSAGES_DETAIL,
            { id: message.id() },
        );

        return (
            <li className="ps-preview-message">
                <div className="ps-preview-message-avatar">
                    <img
                        src={message.userAvatar() || imgDefaultUser}
                        width="40"
                        height="40"
                        alt="User"
                        className="media-object user-image"
                    />
                </div>
                <div className="ps-preview-message-time">
                    <i className="material-icons">access_time</i>
                    <span>{message.dateDescription()}</span>
                </div>
                <div className="ps-preview-message-title">
                    {message.title()}
                </div>
                <div className="ps-preview-message-body">
                    {message.body() || '-'}
                </div>
                <div className="ps-preview-message-link">
                    <Link
                        to={toDetail}
                        children={I18nUtils.tr('TR_LEER_MENSAJE')}
                    />
                </div>
            </li>
        );
    }
}

MessagePreviewListItem.propTypes = {
    message: PropTypes.object.isRequired,
};

MessagePreviewListItem.defaultProps = {};



// WEBPACK FOOTER //
// ./src/app/messages-notifications/messages/preview-list/MessagePreviewListItem.jsx